
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const ActivationResetType = {
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  ACCOUNT_ACTIVATION: 'ACCOUNT_ACTIVATION'
} as const

export type ActivationResetType = (typeof ActivationResetType)[keyof typeof ActivationResetType]


export const SchoolyearResult = {
  NONE: 'NONE',
  BLUEPRINT_USED: 'BLUEPRINT_USED',
  COPIED_LAST_YEAR: 'COPIED_LAST_YEAR'
} as const

export type SchoolyearResult = (typeof SchoolyearResult)[keyof typeof SchoolyearResult]


export const CustomerState = {
  possible_customer: 'possible_customer',
  trial_account: 'trial_account',
  customer: 'customer',
  old_trial: 'old_trial',
  old_customer: 'old_customer',
  not_longer_active: 'not_longer_active',
  never_a_customer: 'never_a_customer',
  other: 'other',
  student: 'student',
  demo: 'demo',
  old_student: 'old_student',
  supplier: 'supplier'
} as const

export type CustomerState = (typeof CustomerState)[keyof typeof CustomerState]


export const OrganizationType = {
  other: 'other',
  primary_school: 'primary_school',
  company: 'company',
  scholar_organization: 'scholar_organization',
  cultural: 'cultural',
  cultural_org: 'cultural_org',
  educ_org: 'educ_org',
  fund: 'fund',
  government: 'government',
  higher_education: 'higher_education',
  ikc: 'ikc',
  child_support: 'child_support',
  middle_school: 'middle_school',
  music_organization: 'music_organization',
  music_club: 'music_club',
  public_broad: 'public_broad',
  unknown: 'unknown',
  other_education: 'other_education',
  multiple_schools: 'multiple_schools',
  so: 'so',
  so_vso: 'so_vso',
  special_education: 'special_education',
  student: 'student',
  newer_middle_school: 'newer_middle_school',
  vso: 'vso',
  health_education: 'health_education',
  zzp: 'zzp',
  empty: 'empty',
  supplier: 'supplier'
} as const

export type OrganizationType = (typeof OrganizationType)[keyof typeof OrganizationType]


export const PublishStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED',
  READY_TO_PUBLISH: 'READY_TO_PUBLISH'
} as const

export type PublishStatus = (typeof PublishStatus)[keyof typeof PublishStatus]


export const Province = {
  belgium: 'belgium',
  buiten_eu: 'buiten_eu',
  drenthe: 'drenthe',
  flevoland: 'flevoland',
  friesland: 'friesland',
  gelderland: 'gelderland',
  groningen: 'groningen',
  nationaal: 'nationaal',
  limburg: 'limburg',
  noord_brabant: 'noord_brabant',
  noord_holland: 'noord_holland',
  rest_eu: 'rest_eu',
  overijssel: 'overijssel',
  utrecht: 'utrecht',
  zeeland: 'zeeland',
  zuid_holland: 'zuid_holland',
  empty: 'empty'
} as const

export type Province = (typeof Province)[keyof typeof Province]


export const SubscriptionType = {
  SCHOOL_SUBSCRIPTION: 'SCHOOL_SUBSCRIPTION',
  CUSTOM_SCHOOL_SUBSCRIPTION: 'CUSTOM_SCHOOL_SUBSCRIPTION',
  INDIVIDUAL_SUBSCRIPTION: 'INDIVIDUAL_SUBSCRIPTION',
  CULTURAL_ORGANIZATION_SUBSCRIPTION: 'CULTURAL_ORGANIZATION_SUBSCRIPTION',
  CHILDCARE_SUBSCRIPTION: 'CHILDCARE_SUBSCRIPTION',
  SURFCONEXT_SUBSCRIPTION: 'SURFCONEXT_SUBSCRIPTION',
  TEMPORARY_STUDENT_SUBSCRIPTION: 'TEMPORARY_STUDENT_SUBSCRIPTION',
  TEMPORARY_TEACHER_SUBSCRIPTION: 'TEMPORARY_TEACHER_SUBSCRIPTION',
  SPECIAL_EDUCATION_SUBSCRIPTION: 'SPECIAL_EDUCATION_SUBSCRIPTION',
  OUTSIDE_SCHOOL_SUBSCRIPTION: 'OUTSIDE_SCHOOL_SUBSCRIPTION'
} as const

export type SubscriptionType = (typeof SubscriptionType)[keyof typeof SubscriptionType]


export const DigestRecurrence = {
  DIRECT: 'DIRECT',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  NO_MAIL: 'NO_MAIL'
} as const

export type DigestRecurrence = (typeof DigestRecurrence)[keyof typeof DigestRecurrence]


export const SeenGroupMessageState = {
  CLOSED: 'CLOSED'
} as const

export type SeenGroupMessageState = (typeof SeenGroupMessageState)[keyof typeof SeenGroupMessageState]


export const SeenGroupMessageType = {
  MIGRATE_MESSAGE: 'MIGRATE_MESSAGE',
  MIGRATE_BANNER: 'MIGRATE_BANNER'
} as const

export type SeenGroupMessageType = (typeof SeenGroupMessageType)[keyof typeof SeenGroupMessageType]


export const PopoverState = {
  MINIMIZED: 'MINIMIZED',
  CLOSED: 'CLOSED'
} as const

export type PopoverState = (typeof PopoverState)[keyof typeof PopoverState]


export const PageType = {
  HOME: 'HOME',
  HOME_V2: 'HOME_V2',
  HOME_V3: 'HOME_V3',
  HOME_V3_1: 'HOME_V3_1',
  HOME_NIEUWSFLITS_17: 'HOME_NIEUWSFLITS_17',
  HOME_NIEUWSFLITS_18: 'HOME_NIEUWSFLITS_18',
  HOME_NIEUWSFLITS_19: 'HOME_NIEUWSFLITS_19',
  HOME_NIEUWSFLITS_20: 'HOME_NIEUWSFLITS_20',
  HOME_NIEUWSFLITS_21: 'HOME_NIEUWSFLITS_21',
  HOME_NIEUWSFLITS_22: 'HOME_NIEUWSFLITS_22',
  HOME_KERST_WENS_2024: 'HOME_KERST_WENS_2024',
  LEARNING_LINE: 'LEARNING_LINE',
  CATEGORIES_THEMES: 'CATEGORIES_THEMES',
  PLAYLIST_MODAL: 'PLAYLIST_MODAL',
  KIDS_CODES: 'KIDS_CODES',
  KIDS_SUBMIT: 'KIDS_SUBMIT',
  STUDIO: 'STUDIO',
  SCHOOLYEAR: 'SCHOOLYEAR',
  NEW_SCHOOLYEAR: 'NEW_SCHOOLYEAR',
  SCHOOL_LIST_PUBLISHED: 'SCHOOL_LIST_PUBLISHED',
  SCHOOL_LIST_UNPUBLISH: 'SCHOOL_LIST_UNPUBLISH',
  CALENDAR: 'CALENDAR',
  TEACHER: 'TEACHER',
  SCHOOL_LISTS_UPDATED: 'SCHOOL_LISTS_UPDATED',
  DISCOVERY: 'DISCOVERY',
  DISCOVERY_WELCOME_TOUR: 'DISCOVERY_WELCOME_TOUR',
  DISCOVERY_SCHOOL_MANAGEMENT_TOUR: 'DISCOVERY_SCHOOL_MANAGEMENT_TOUR',
  NEW_INITIATOR_ANNOUNCEMENT: 'NEW_INITIATOR_ANNOUNCEMENT'
} as const

export type PageType = (typeof PageType)[keyof typeof PageType]


export const UserRole = {
  ADMIN: 'ADMIN',
  STUDENT: 'STUDENT',
  USER: 'USER',
  KID: 'KID'
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]


export const OrganizationUserRole = {
  MANAGER: 'MANAGER',
  INITIATOR: 'INITIATOR',
  MEMBER: 'MEMBER'
} as const

export type OrganizationUserRole = (typeof OrganizationUserRole)[keyof typeof OrganizationUserRole]


export const OnboardingStep = {
  WELCOME: 'WELCOME',
  GROUPS: 'GROUPS',
  CHOICE_PAGE: 'CHOICE_PAGE',
  NEWSLETTER: 'NEWSLETTER',
  EDIT_GROUPS: 'EDIT_GROUPS'
} as const

export type OnboardingStep = (typeof OnboardingStep)[keyof typeof OnboardingStep]


export const CommunicationRole = {
  NONE: 'NONE',
  INITIATOR: 'INITIATOR',
  TEACHER: 'TEACHER'
} as const

export type CommunicationRole = (typeof CommunicationRole)[keyof typeof CommunicationRole]


export const OnboardingType = {
  NONE: 'NONE',
  ONBOARDING: 'ONBOARDING',
  SCHOOLYEAR: 'SCHOOLYEAR'
} as const

export type OnboardingType = (typeof OnboardingType)[keyof typeof OnboardingType]


export const GroupMigrationState = {
  INIT: 'INIT',
  NOT_MIGRATED: 'NOT_MIGRATED',
  MIGRATED: 'MIGRATED',
  MIGRATION_NOT_POSSIBLE: 'MIGRATION_NOT_POSSIBLE'
} as const

export type GroupMigrationState = (typeof GroupMigrationState)[keyof typeof GroupMigrationState]


export const TokenType = {
  RESET_PASSWORD: 'RESET_PASSWORD',
  ACTIVATE_ACCOUNT: 'ACTIVATE_ACCOUNT'
} as const

export type TokenType = (typeof TokenType)[keyof typeof TokenType]


export const FileType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  ZIP: 'ZIP',
  PDF: 'PDF',
  DOC: 'DOC',
  XLS: 'XLS',
  XML: 'XML',
  PPT: 'PPT',
  JSON: 'JSON',
  OTHER: 'OTHER'
} as const

export type FileType = (typeof FileType)[keyof typeof FileType]


export const FileStatus = {
  INIT: 'INIT',
  UPLOADED: 'UPLOADED',
  PROCESSED: 'PROCESSED'
} as const

export type FileStatus = (typeof FileStatus)[keyof typeof FileStatus]


export const FileVariantType = {
  SMALL_360P: 'SMALL_360P',
  MEDIUM_720P: 'MEDIUM_720P',
  LARGE_1080P: 'LARGE_1080P'
} as const

export type FileVariantType = (typeof FileVariantType)[keyof typeof FileVariantType]


export const PlayButtonLocation = {
  TOP_LEFT: 'TOP_LEFT',
  TOP_MIDDLE: 'TOP_MIDDLE',
  TOP_RIGHT: 'TOP_RIGHT',
  CENTER_LEFT: 'CENTER_LEFT',
  CENTER_MIDDLE: 'CENTER_MIDDLE',
  CENTER_RIGHT: 'CENTER_RIGHT',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  BOTTOM_MIDDLE: 'BOTTOM_MIDDLE',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT'
} as const

export type PlayButtonLocation = (typeof PlayButtonLocation)[keyof typeof PlayButtonLocation]


export const AudioElementPosition = {
  CENTER_BOTTOM: 'CENTER_BOTTOM',
  CENTER_MIDDLE: 'CENTER_MIDDLE'
} as const

export type AudioElementPosition = (typeof AudioElementPosition)[keyof typeof AudioElementPosition]


export const SavedSubjectStatus = {
  SAVED: 'SAVED',
  SUBMITTED: 'SUBMITTED',
  COMMENTED: 'COMMENTED',
  REOPENED: 'REOPENED'
} as const

export type SavedSubjectStatus = (typeof SavedSubjectStatus)[keyof typeof SavedSubjectStatus]


export const QuestionAudioPostion = {
  TITLE_BOTTOM: 'TITLE_BOTTOM',
  TITLE_LEFT: 'TITLE_LEFT'
} as const

export type QuestionAudioPostion = (typeof QuestionAudioPostion)[keyof typeof QuestionAudioPostion]


export const GridDisplayOptions = {
  AUTO: 'AUTO',
  ONE: 'ONE',
  TWO: 'TWO',
  THREE: 'THREE',
  FOUR: 'FOUR',
  FIVE: 'FIVE',
  SIX: 'SIX',
  SEVEN: 'SEVEN',
  EIGHT: 'EIGHT',
  NINE: 'NINE',
  TEN: 'TEN'
} as const

export type GridDisplayOptions = (typeof GridDisplayOptions)[keyof typeof GridDisplayOptions]


export const MobileGridDisplayOptions = {
  ONE: 'ONE',
  TWO: 'TWO'
} as const

export type MobileGridDisplayOptions = (typeof MobileGridDisplayOptions)[keyof typeof MobileGridDisplayOptions]


export const QuestionDisplayType = {
  TEXT: 'TEXT',
  TEXT_WITH_IMAGE: 'TEXT_WITH_IMAGE',
  TEXT_WITH_AUDIO: 'TEXT_WITH_AUDIO',
  TEXT_WITH_VIDEO: 'TEXT_WITH_VIDEO',
  TEXT_WITH_IMAGE_AND_AUDIO: 'TEXT_WITH_IMAGE_AND_AUDIO'
} as const

export type QuestionDisplayType = (typeof QuestionDisplayType)[keyof typeof QuestionDisplayType]


export const ResponseType = {
  SINGLE_ANSWER: 'SINGLE_ANSWER',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE'
} as const

export type ResponseType = (typeof ResponseType)[keyof typeof ResponseType]


export const AnswerDisplayType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  IMAGE_WITH_TEXT: 'IMAGE_WITH_TEXT',
  IMAGE_WITH_AUDIO: 'IMAGE_WITH_AUDIO',
  IMAGE_WITH_AUDIO_AND_TEXT: 'IMAGE_WITH_AUDIO_AND_TEXT',
  AUDIO_WITH_TEXT: 'AUDIO_WITH_TEXT',
  VIDEO_WITH_TEXT: 'VIDEO_WITH_TEXT'
} as const

export type AnswerDisplayType = (typeof AnswerDisplayType)[keyof typeof AnswerDisplayType]


export const ColumnDisplayType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  IMAGE_WITH_TEXT: 'IMAGE_WITH_TEXT'
} as const

export type ColumnDisplayType = (typeof ColumnDisplayType)[keyof typeof ColumnDisplayType]


export const ColumnOptionSides = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT'
} as const

export type ColumnOptionSides = (typeof ColumnOptionSides)[keyof typeof ColumnOptionSides]


export const OptionDisplayType = {
  ROW: 'ROW',
  CARD: 'CARD'
} as const

export type OptionDisplayType = (typeof OptionDisplayType)[keyof typeof OptionDisplayType]


export const ImageDisplayRatio = {
  SQUARE: 'SQUARE',
  LANDSCAPE_16_9: 'LANDSCAPE_16_9'
} as const

export type ImageDisplayRatio = (typeof ImageDisplayRatio)[keyof typeof ImageDisplayRatio]


export const VerticalQuestionImageDisplayRatio = {
  SQUARE: 'SQUARE',
  LANDSCAPE_16_9: 'LANDSCAPE_16_9',
  LANDSCAPE_32_9: 'LANDSCAPE_32_9'
} as const

export type VerticalQuestionImageDisplayRatio = (typeof VerticalQuestionImageDisplayRatio)[keyof typeof VerticalQuestionImageDisplayRatio]


export const MixMatchRightColumnOptionDisplayType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  IMAGE_WITH_TEXT: 'IMAGE_WITH_TEXT'
} as const

export type MixMatchRightColumnOptionDisplayType = (typeof MixMatchRightColumnOptionDisplayType)[keyof typeof MixMatchRightColumnOptionDisplayType]


export const BlockType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  QUESTION: 'QUESTION',
  LINK: 'LINK'
} as const

export type BlockType = (typeof BlockType)[keyof typeof BlockType]


export const BlockTitleType = {
  H1: 'H1',
  H2: 'H2',
  H3: 'H3',
  H4: 'H4',
  H5: 'H5',
  H6: 'H6'
} as const

export type BlockTitleType = (typeof BlockTitleType)[keyof typeof BlockTitleType]


export const SongTextSecondaryType = {
  SECONDARY: 'SECONDARY',
  TRANSLATION: 'TRANSLATION',
  PHONETIC: 'PHONETIC'
} as const

export type SongTextSecondaryType = (typeof SongTextSecondaryType)[keyof typeof SongTextSecondaryType]


export const LessonFeedbackScore = {
  NONE: 'NONE',
  POOR: 'POOR',
  OKAY: 'OKAY',
  GOOD: 'GOOD',
  EXCELLENT: 'EXCELLENT',
  STELLAR: 'STELLAR'
} as const

export type LessonFeedbackScore = (typeof LessonFeedbackScore)[keyof typeof LessonFeedbackScore]


export const PoorLessonFeedbackReason = {
  BETTER_AUDIO: 'BETTER_AUDIO',
  BETTER_VIDEO: 'BETTER_VIDEO',
  TOO_DIFFICULT: 'TOO_DIFFICULT',
  TOO_EASY: 'TOO_EASY',
  CUSTOM: 'CUSTOM'
} as const

export type PoorLessonFeedbackReason = (typeof PoorLessonFeedbackReason)[keyof typeof PoorLessonFeedbackReason]


export const PublicLessonButtonVariant = {
  filled: 'filled',
  bordered: 'bordered'
} as const

export type PublicLessonButtonVariant = (typeof PublicLessonButtonVariant)[keyof typeof PublicLessonButtonVariant]


export const LessonType = {
  LESSON: 'LESSON',
  SONG: 'SONG'
} as const

export type LessonType = (typeof LessonType)[keyof typeof LessonType]


export const ContentSubjectType = {
  MUSIC: 'MUSIC',
  DRAMA: 'DRAMA',
  DANCE: 'DANCE'
} as const

export type ContentSubjectType = (typeof ContentSubjectType)[keyof typeof ContentSubjectType]


export const MenuItemType = {
  NONE: 'NONE',
  ALL_SUBJECTS: 'ALL_SUBJECTS',
  CUSTOM: 'CUSTOM'
} as const

export type MenuItemType = (typeof MenuItemType)[keyof typeof MenuItemType]


export const InformationVisibility = {
  SAME: 'SAME',
  DIFFERENT: 'DIFFERENT'
} as const

export type InformationVisibility = (typeof InformationVisibility)[keyof typeof InformationVisibility]


export const MenuItemLinkType = {
  URL: 'URL',
  SUBJECT: 'SUBJECT'
} as const

export type MenuItemLinkType = (typeof MenuItemLinkType)[keyof typeof MenuItemLinkType]


export const SlideType = {
  CUSTOM: 'CUSTOM',
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  YOUTUBE: 'YOUTUBE',
  YOUTUBE_SYNC: 'YOUTUBE_SYNC',
  SONGBOX: 'SONGBOX',
  HORIZONTAL_QUESTION: 'HORIZONTAL_QUESTION',
  VERTICAL_QUESTION: 'VERTICAL_QUESTION',
  TEXT_BOX_QUESTION: 'TEXT_BOX_QUESTION',
  QUESTION: 'QUESTION',
  HORIZONTAL_ROW: 'HORIZONTAL_ROW',
  VERTICAL_ROW: 'VERTICAL_ROW',
  COLUMN_SORT: 'COLUMN_SORT',
  MIX_MATCH: 'MIX_MATCH',
  COMPOSER: 'COMPOSER',
  CONTAINER: 'CONTAINER',
  QUESTION_SERIE: 'QUESTION_SERIE',
  SUBMIT: 'SUBMIT'
} as const

export type SlideType = (typeof SlideType)[keyof typeof SlideType]


export const SlideVisibility = {
  BOTH: 'BOTH',
  KIDS_ONLY: 'KIDS_ONLY',
  TEACHERS_ONLY: 'TEACHERS_ONLY'
} as const

export type SlideVisibility = (typeof SlideVisibility)[keyof typeof SlideVisibility]


export const CustomLabelColor = {
  BLUE: 'BLUE',
  RED: 'RED',
  YELLOW: 'YELLOW',
  ORANGE: 'ORANGE'
} as const

export type CustomLabelColor = (typeof CustomLabelColor)[keyof typeof CustomLabelColor]


export const ToolState = {
  NONE: 'NONE',
  DRAW: 'DRAW',
  STAMP: 'STAMP'
} as const

export type ToolState = (typeof ToolState)[keyof typeof ToolState]


export const VisibilityState = {
  DEFAULT: 'DEFAULT',
  HIDDEN: 'HIDDEN',
  VISIBLE: 'VISIBLE'
} as const

export type VisibilityState = (typeof VisibilityState)[keyof typeof VisibilityState]


export const DrawStampSize = {
  DEFAULT: 'DEFAULT',
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
  EXTRA_LARGE: 'EXTRA_LARGE'
} as const

export type DrawStampSize = (typeof DrawStampSize)[keyof typeof DrawStampSize]


export const TitleBalkColor = {
  DEFAULT: 'DEFAULT',
  MUZIEK: 'MUZIEK',
  LILAC: 'LILAC',
  DANS: 'DANS',
  ORANGE: 'ORANGE',
  DRAMA: 'DRAMA',
  RED: 'RED',
  GREEN: 'GREEN'
} as const

export type TitleBalkColor = (typeof TitleBalkColor)[keyof typeof TitleBalkColor]


export const CustomSlideElementType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  RECT: 'RECT',
  CIRCLE: 'CIRCLE',
  BUTTON: 'BUTTON',
  LABEL: 'LABEL',
  ICON: 'ICON',
  VIDEO: 'VIDEO',
  TAG: 'TAG',
  AUDIO: 'AUDIO',
  STAMP: 'STAMP'
} as const

export type CustomSlideElementType = (typeof CustomSlideElementType)[keyof typeof CustomSlideElementType]


export const TextAlign = {
  left: 'left',
  center: 'center',
  right: 'right'
} as const

export type TextAlign = (typeof TextAlign)[keyof typeof TextAlign]


export const VerticalTextAlign = {
  top: 'top',
  middle: 'middle',
  bottom: 'bottom'
} as const

export type VerticalTextAlign = (typeof VerticalTextAlign)[keyof typeof VerticalTextAlign]


export const CustomSlideTextElementType = {
  TEXT: 'TEXT',
  RICH_TEXT: 'RICH_TEXT'
} as const

export type CustomSlideTextElementType = (typeof CustomSlideTextElementType)[keyof typeof CustomSlideTextElementType]


export const FontStyle = {
  normal: 'normal',
  italic: 'italic',
  bold: 'bold',
  bold_italic: 'bold_italic'
} as const

export type FontStyle = (typeof FontStyle)[keyof typeof FontStyle]


export const FontVariant = {
  normal: 'normal',
  small_caps: 'small_caps'
} as const

export type FontVariant = (typeof FontVariant)[keyof typeof FontVariant]


export const TextDecoration = {
  line_through: 'line_through',
  underline: 'underline',
  normal: 'normal'
} as const

export type TextDecoration = (typeof TextDecoration)[keyof typeof TextDecoration]


export const Wrap = {
  none: 'none',
  word: 'word',
  char: 'char'
} as const

export type Wrap = (typeof Wrap)[keyof typeof Wrap]


export const CustomSlideAudioElementDisplayType = {
  PLAY: 'PLAY',
  EAR: 'EAR',
  IMAGE: 'IMAGE'
} as const

export type CustomSlideAudioElementDisplayType = (typeof CustomSlideAudioElementDisplayType)[keyof typeof CustomSlideAudioElementDisplayType]


export const CustomSlideAudioElementBehaviour = {
  PLAY_STOP: 'PLAY_STOP',
  PLAY_STOP_FADE_OUT: 'PLAY_STOP_FADE_OUT',
  PLAY_PAUSE: 'PLAY_PAUSE',
  PLAY_REPLAY: 'PLAY_REPLAY'
} as const

export type CustomSlideAudioElementBehaviour = (typeof CustomSlideAudioElementBehaviour)[keyof typeof CustomSlideAudioElementBehaviour]


export const CustomSlideArrowElementDirection = {
  none: 'none',
  up: 'up',
  right: 'right',
  down: 'down',
  left: 'left'
} as const

export type CustomSlideArrowElementDirection = (typeof CustomSlideArrowElementDirection)[keyof typeof CustomSlideArrowElementDirection]


export const LinkType = {
  URL: 'URL',
  DOWNLOAD: 'DOWNLOAD',
  SLIDE: 'SLIDE',
  MODAL: 'MODAL'
} as const

export type LinkType = (typeof LinkType)[keyof typeof LinkType]


export const UrlTarget = {
  BLANK: 'BLANK',
  SELF: 'SELF'
} as const

export type UrlTarget = (typeof UrlTarget)[keyof typeof UrlTarget]


export const FilterOptionLevel = {
  LESSON: 'LESSON',
  HEAD_SUBJECT: 'HEAD_SUBJECT'
} as const

export type FilterOptionLevel = (typeof FilterOptionLevel)[keyof typeof FilterOptionLevel]


export const ComposerToolType = {
  STIPPENTOOL: 'STIPPENTOOL',
  RITMETOOL: 'RITMETOOL',
  BOOMWACKERTOOL: 'BOOMWACKERTOOL',
  DRUMANDBASSTOOL: 'DRUMANDBASSTOOL'
} as const

export type ComposerToolType = (typeof ComposerToolType)[keyof typeof ComposerToolType]


export const LessonPlaylistType = {
  LESSON: 'LESSON',
  LL: 'LL'
} as const

export type LessonPlaylistType = (typeof LessonPlaylistType)[keyof typeof LessonPlaylistType]


export const UserListAccessLevel = {
  PERSONAL: 'PERSONAL',
  GROUP: 'GROUP',
  KIDS: 'KIDS',
  SCHOOL: 'SCHOOL',
  GLOBAL: 'GLOBAL'
} as const

export type UserListAccessLevel = (typeof UserListAccessLevel)[keyof typeof UserListAccessLevel]


export const UserListType = {
  PLAYLIST: 'PLAYLIST',
  LL: 'LL',
  THEME: 'THEME'
} as const

export type UserListType = (typeof UserListType)[keyof typeof UserListType]


export const SortItemsBy = {
  CUSTOM: 'CUSTOM',
  DATE_ASC: 'DATE_ASC',
  DATE_DESC: 'DATE_DESC',
  TITLE_ASC: 'TITLE_ASC',
  TITLE_DESC: 'TITLE_DESC'
} as const

export type SortItemsBy = (typeof SortItemsBy)[keyof typeof SortItemsBy]


export const ListDisplayType = {
  LIST: 'LIST',
  GRID: 'GRID'
} as const

export type ListDisplayType = (typeof ListDisplayType)[keyof typeof ListDisplayType]


export const UserPlaylistHomeSlotPosition = {
  FIRST: 'FIRST',
  SECOND: 'SECOND',
  THIRD: 'THIRD'
} as const

export type UserPlaylistHomeSlotPosition = (typeof UserPlaylistHomeSlotPosition)[keyof typeof UserPlaylistHomeSlotPosition]


export const BulletinBoardItemType = {
  LESSON: 'LESSON',
  THEME: 'THEME',
  THEME_GROUP: 'THEME_GROUP',
  LL_PAGE: 'LL_PAGE',
  SCHOOL_LIST: 'SCHOOL_LIST',
  GROUP_LIST: 'GROUP_LIST',
  KIDS_LIST: 'KIDS_LIST',
  PERSONAL_LIST: 'PERSONAL_LIST',
  LL: 'LL',
  KIDS_PREVIEW: 'KIDS_PREVIEW',
  SUPPORT: 'SUPPORT',
  YOUTUBE: 'YOUTUBE',
  URL: 'URL'
} as const

export type BulletinBoardItemType = (typeof BulletinBoardItemType)[keyof typeof BulletinBoardItemType]


export const GeneratedBy = {
  A_MIGRATION: 'A_MIGRATION',
  B_ONBOARDING: 'B_ONBOARDING',
  C_USER: 'C_USER',
  D_SCHOOLYEAR: 'D_SCHOOLYEAR'
} as const

export type GeneratedBy = (typeof GeneratedBy)[keyof typeof GeneratedBy]


export const PlaylistShareAccess = {
  READ_ONLY: 'READ_ONLY',
  READ_WRITE: 'READ_WRITE'
} as const

export type PlaylistShareAccess = (typeof PlaylistShareAccess)[keyof typeof PlaylistShareAccess]


export const ShareType = {
  PLAYLIST: 'PLAYLIST',
  LESSON: 'LESSON',
  THEME: 'THEME',
  LL: 'LL'
} as const

export type ShareType = (typeof ShareType)[keyof typeof ShareType]


export const ShareStatus = {
  NEW: 'NEW',
  DIGEST_PROCESSING: 'DIGEST_PROCESSING',
  DIGEST_SEND: 'DIGEST_SEND'
} as const

export type ShareStatus = (typeof ShareStatus)[keyof typeof ShareStatus]


export const DiscoveryContentBlockType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  LIST: 'LIST',
  LINK_LIST: 'LINK_LIST',
  CARDS: 'CARDS',
  SPLIT_BLOCK: 'SPLIT_BLOCK'
} as const

export type DiscoveryContentBlockType = (typeof DiscoveryContentBlockType)[keyof typeof DiscoveryContentBlockType]


export const ListBlockIconType = {
  CHECK: 'CHECK'
} as const

export type ListBlockIconType = (typeof ListBlockIconType)[keyof typeof ListBlockIconType]


export const SplitContentBlockAlignment = {
  TOP: 'TOP',
  CENTER: 'CENTER'
} as const

export type SplitContentBlockAlignment = (typeof SplitContentBlockAlignment)[keyof typeof SplitContentBlockAlignment]


export const SplitContentBlockRatio = {
  SPLIT_50_50: 'SPLIT_50_50',
  SPLIT_60_40: 'SPLIT_60_40',
  SPLIT_40_60: 'SPLIT_40_60',
  SPLIT_70_30: 'SPLIT_70_30',
  SPLIT_30_70: 'SPLIT_30_70'
} as const

export type SplitContentBlockRatio = (typeof SplitContentBlockRatio)[keyof typeof SplitContentBlockRatio]


export const DiscoveryTourStatusType = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED'
} as const

export type DiscoveryTourStatusType = (typeof DiscoveryTourStatusType)[keyof typeof DiscoveryTourStatusType]


export const SupportContentType = {
  HOME: 'HOME',
  LIBRARY_DEFAULT: 'LIBRARY_DEFAULT',
  LIBRARY_KIDS_LIST: 'LIBRARY_KIDS_LIST',
  LIBRARY_BULLETIN_BOARD: 'LIBRARY_BULLETIN_BOARD',
  LIBRARY_MANAGE_SCHOOLLIST: 'LIBRARY_MANAGE_SCHOOLLIST',
  LIBRARY_SHARE_LIST: 'LIBRARY_SHARE_LIST',
  ARCHIVE_DEFAULT: 'ARCHIVE_DEFAULT',
  ARCHIVE_KIDS_LIST: 'ARCHIVE_KIDS_LIST',
  CATEGORIES_OVERVIEW: 'CATEGORIES_OVERVIEW',
  CATEGORY_DETAIL: 'CATEGORY_DETAIL',
  THEME_DETAIL: 'THEME_DETAIL',
  LEARNING_LINE_OVERVIEW: 'LEARNING_LINE_OVERVIEW',
  LEARNING_LINE_SPECIAL_OVERVIEW: 'LEARNING_LINE_SPECIAL_OVERVIEW',
  LEARNING_LINE_TODDLER_OVERVIEW: 'LEARNING_LINE_TODDLER_OVERVIEW',
  LEARNING_LINE_DETAIL: 'LEARNING_LINE_DETAIL',
  LEARNING_LINE_TODDLER_DETAIL: 'LEARNING_LINE_TODDLER_DETAIL',
  LEARNING_LINE_SPECIAL_DETAIL: 'LEARNING_LINE_SPECIAL_DETAIL',
  LESSON_DETAIL: 'LESSON_DETAIL',
  SONG_DETAIL: 'SONG_DETAIL',
  KIDS_CODES: 'KIDS_CODES',
  KIDS_ASSIGNEMENTS: 'KIDS_ASSIGNEMENTS',
  STUDIO: 'STUDIO',
  TEACHER: 'TEACHER',
  CALENDAR: 'CALENDAR',
  PROFILE: 'PROFILE',
  SEARCH: 'SEARCH',
  MY_SCHOOL_OVERVIEW: 'MY_SCHOOL_OVERVIEW',
  SCHOOL_MANAGEMENT_OVERVIEW: 'SCHOOL_MANAGEMENT_OVERVIEW',
  SCHOOL_MANAGEMENT_GROUPS: 'SCHOOL_MANAGEMENT_GROUPS',
  SCHOOL_MANAGEMENT_USERS: 'SCHOOL_MANAGEMENT_USERS',
  SCHOOL_MANAGEMENT_123ZING_PLAN: 'SCHOOL_MANAGEMENT_123ZING_PLAN'
} as const

export type SupportContentType = (typeof SupportContentType)[keyof typeof SupportContentType]


export const AvailabilityType = {
  PUBLIC_ONLY: 'PUBLIC_ONLY',
  PRIVATE_ONLY: 'PRIVATE_ONLY',
  BOTH: 'BOTH'
} as const

export type AvailabilityType = (typeof AvailabilityType)[keyof typeof AvailabilityType]


export const ContentBlockType = {
  TEXT: 'TEXT',
  TEXT_2: 'TEXT_2',
  STACKED_TEXT: 'STACKED_TEXT',
  TITLE: 'TITLE',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  YOUTUBE: 'YOUTUBE',
  SUPPORT_ITEM: 'SUPPORT_ITEM'
} as const

export type ContentBlockType = (typeof ContentBlockType)[keyof typeof ContentBlockType]


export const SupportItemType = {
  QUESTION: 'QUESTION',
  EXCLAMATION: 'EXCLAMATION',
  TIP: 'TIP'
} as const

export type SupportItemType = (typeof SupportItemType)[keyof typeof SupportItemType]


export const ContentBlockTitleSize = {
  LARGE: 'LARGE',
  SMALL: 'SMALL'
} as const

export type ContentBlockTitleSize = (typeof ContentBlockTitleSize)[keyof typeof ContentBlockTitleSize]


export const ContentBlockImageWideness = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE'
} as const

export type ContentBlockImageWideness = (typeof ContentBlockImageWideness)[keyof typeof ContentBlockImageWideness]


export const Alignment = {
  LEFT: 'LEFT',
  CENTER: 'CENTER',
  RIGHT: 'RIGHT'
} as const

export type Alignment = (typeof Alignment)[keyof typeof Alignment]


export const TimerSize = {
  BIG: 'BIG',
  SMALL: 'SMALL'
} as const

export type TimerSize = (typeof TimerSize)[keyof typeof TimerSize]


export const TimerPosition = {
  TOP_LEFT: 'TOP_LEFT',
  TOP_MIDDLE: 'TOP_MIDDLE',
  TOP_RIGHT: 'TOP_RIGHT',
  CENTER_LEFT: 'CENTER_LEFT',
  CENTER_MIDDLE: 'CENTER_MIDDLE',
  CENTER_RIGHT: 'CENTER_RIGHT',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  BOTTOM_MIDDLE: 'BOTTOM_MIDDLE',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT'
} as const

export type TimerPosition = (typeof TimerPosition)[keyof typeof TimerPosition]


export const Position = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM'
} as const

export type Position = (typeof Position)[keyof typeof Position]


export const ContentBlockCardsTemplate = {
  HEADER: 'HEADER',
  CARDS: 'CARDS',
  CARDS_FEATURED: 'CARDS_FEATURED',
  COMPACT_CARDS: 'COMPACT_CARDS',
  LEERLIJN: 'LEERLIJN',
  DOWNLOADS: 'DOWNLOADS',
  SCHOOLING: 'SCHOOLING',
  BANNER: 'BANNER',
  DEZE_WEEK: 'DEZE_WEEK',
  LAATSTE_NIEUWS: 'LAATSTE_NIEUWS',
  TIPS_EN_TRUCS: 'TIPS_EN_TRUCS'
} as const

export type ContentBlockCardsTemplate = (typeof ContentBlockCardsTemplate)[keyof typeof ContentBlockCardsTemplate]


export const ContentBlockCardsBannerAlignment = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT'
} as const

export type ContentBlockCardsBannerAlignment = (typeof ContentBlockCardsBannerAlignment)[keyof typeof ContentBlockCardsBannerAlignment]


export const CardType = {
  THEME: 'THEME',
  NEWS: 'NEWS',
  TIP: 'TIP',
  EXTERN: 'EXTERN',
  LEARNING_LINE: 'LEARNING_LINE',
  LESSON: 'LESSON'
} as const

export type CardType = (typeof CardType)[keyof typeof CardType]


export const ContrastType = {
  LIGHT: 'LIGHT',
  DARK: 'DARK'
} as const

export type ContrastType = (typeof ContrastType)[keyof typeof ContrastType]


export const CardDisplayType = {
  IMAGE_BACKGROUND: 'IMAGE_BACKGROUND',
  IMAGE_LABEL: 'IMAGE_LABEL',
  DISCOVERY_CARD: 'DISCOVERY_CARD'
} as const

export type CardDisplayType = (typeof CardDisplayType)[keyof typeof CardDisplayType]


export const CardLinkColor = {
  ORANGE: 'ORANGE',
  GREEN: 'GREEN'
} as const

export type CardLinkColor = (typeof CardLinkColor)[keyof typeof CardLinkColor]


export const CardImageStyle = {
  COVER: 'COVER',
  CONTAIN: 'CONTAIN',
  FILL: 'FILL'
} as const

export type CardImageStyle = (typeof CardImageStyle)[keyof typeof CardImageStyle]


export const NewsItemVideoType = {
  YOUTUBE: 'YOUTUBE',
  VIDEO: 'VIDEO'
} as const

export type NewsItemVideoType = (typeof NewsItemVideoType)[keyof typeof NewsItemVideoType]


export const RelatedItemType = {
  THEME: 'THEME',
  LESSON: 'LESSON',
  LESSON_LINKED: 'LESSON_LINKED',
  EXTERN: 'EXTERN'
} as const

export type RelatedItemType = (typeof RelatedItemType)[keyof typeof RelatedItemType]


export const BlueprintPeriodState = {
  INACTIVE: 'INACTIVE',
  LAUNCHING: 'LAUNCHING',
  LAUNCHED: 'LAUNCHED'
} as const

export type BlueprintPeriodState = (typeof BlueprintPeriodState)[keyof typeof BlueprintPeriodState]


export const BlueprintState = {
  CONCEPT: 'CONCEPT',
  PUBLISHED: 'PUBLISHED',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
  IGNORED: 'IGNORED'
} as const

export type BlueprintState = (typeof BlueprintState)[keyof typeof BlueprintState]


export const OrderFormThemeMethods = {
  ALL_IN_ONE: 'ALL_IN_ONE',
  BLINK_WORLD: 'BLINK_WORLD',
  DAVINCI: 'DAVINCI',
  FONK_WORLD: 'FONK_WORLD',
  IPC: 'IPC',
  TODDLER_UNIVERSITY: 'TODDLER_UNIVERSITY',
  PIRAMIDE: 'PIRAMIDE',
  UK_AND_PUK: 'UK_AND_PUK',
  FAQTA: 'FAQTA',
  FOUR_TIMES_SMARTER: 'FOUR_TIMES_SMARTER',
  JEELO: 'JEELO',
  TODDLER_PLAINS: 'TODDLER_PLAINS',
  TREASURE_CHEST: 'TREASURE_CHEST',
  EARLYYEARS_IPC: 'EARLYYEARS_IPC',
  CODE_D: 'CODE_D'
} as const

export type OrderFormThemeMethods = (typeof OrderFormThemeMethods)[keyof typeof OrderFormThemeMethods]


export const AdminActionType = {
  DELETE_USER: 'DELETE_USER',
  DELETE_ORGANIZATION: 'DELETE_ORGANIZATION'
} as const

export type AdminActionType = (typeof AdminActionType)[keyof typeof AdminActionType]
